var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLeftArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "13px",
    viewBox: "0 0 14 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "72C98F4B-8241-4172-997B-A87090D23120") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11.1-Help-Center---Video-Tutorials",
    transform: "translate(-165.000000, -255.000000)",
    fill: "#9B9B9B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(164.500000, 252.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.33250054,16.1342182 C8.12640369,16.3658545 7.821727,16.5 7.49998842,16.5 C7.17824984,16.5 6.87357315,16.3658545 6.6674763,16.1339636 L1.25100186,10.0248727 C0.868057121,9.5924 0.930346577,8.94992727 1.38966361,8.59 C1.85087641,8.23007273 2.53226889,8.28861818 2.91629693,8.72032727 L6.41669353,12.6690909 L6.41669353,3.51818182 C6.41669353,2.95538182 6.90119717,2.5 7.49998842,2.5 C8.09877967,2.5 8.58328331,2.95538182 8.58328331,3.51818182 L8.58328331,12.6690909 L12.0839507,8.72058182 C12.4668955,8.28912727 13.1493713,8.23032727 13.6105841,8.59025455 C14.0696303,8.95018182 14.1319197,9.5924 13.748975,10.0251273 L8.33250054,16.1342182 Z",
    id: "Sort-Alphabet-Ascending-path-Copy-10",
    transform: "translate(7.500000, 9.500000) rotate(-270.000000) translate(-7.500000, -9.500000) "
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLeftArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/leftArrow.3068d157080ac8e8fe383fc8f0627e6b.svg";